<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="600" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>

        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>


  import {
    getpersonnellist
  } from '@/api/personnel/personnel.js'

  import {getsysparameterList} from "@/api/system/sys_parameter";

  export default {

    data() {
      return {
        spinShow:false,
        fullscreenLoading:false,
        exportLoading:false,
        index: 1,
        loading: false,
        logModal: false,
        OldMartetList:[],

        searchVal: "",
        single: false,
        loadingStatus: false,
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: "新建"
        },
        tableSelectIdList:[],
        editModalData: "",
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,

            align: 'center'
          },
          {
            title: "编号",
            key: "Num",
            width: 80,

            align: "center",
            sortable: true
          },
          {
            title: "预约时间",
            key: "apply_datetime",
            width: 170,

            align: "center",
            sortable: true
          },
          {
            title: "姓名",
            key: "per_name",
            width: 80,

            align: "center",
            sortable: true
          },
          {
            title: "身份证",
            key: "per_idcard",
            width: 170,

            align: "center",
            sortable: true
          },
          {
            title: "联系电话",
            key: "per_phone",
            width: 120,
            align: "center",
            sortable: true
          },
          {
            title: "代办人姓名",
            key: "entrust_name",
            width: 120,
            align: "center",
            sortable: true
          },
          {
            title: "代办人身份证",
            key: "entrust_idcard",
            width: 170,
            align: "center",
            sortable: true
          },
          {
            title: "代办人电话",
            key: "entrust_phone",
            width: 120,
            align: "center",
            sortable: true
          },
          {
            title: "申请类型",
            key: "type_CN",
            width: 120,
            align: "center",
            sortable: true
          },
          // {
          //   title: "操作",
          //   key: "handle",
          //   width: 130,
          //   align: "center",
          //   render: (h, params) => {
          //     return h("div", [
          //       h(
          //         "Button",
          //         {
          //           props: {
          //             type: "primary",
          //             size: "small"
          //           },
          //           style: {
          //             marginRight: "5px"
          //           },
          //           on: {
          //             click: () => {
          //               this.editModal(params.row, "put", "修改");
          //             }
          //           }
          //         },
          //         "编辑"
          //       ),
          //       h(
          //         "Button",
          //         {
          //           props: {
          //             type: "error",
          //             size: "small"
          //           },
          //           on: {
          //             click: () => {
          //               this.delData(params);
          //             }
          //           }
          //         },
          //         "删除"
          //       )
          //     ]);
          //   }
          // }
        ],
      };
    },
    methods: {

      getapplylist(key, value) {
        // console.log(this.columns[7].filters)
        this.spinShow = true
        getpersonnellist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            // console.log(this.columns[6].filters)
            this.pageTotal = res.data.count
            this.tableData = res.data.data
            // this.columns[8].filters=res.data.police_station_CN;
            // this.columns[9].filters=res.data.idc_CN;
            // this.columns[10].filters=res.data.tv_station_CN;
            // console.log(this.columns[7].filters)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      // table 选中的ID
      handleSelectChange(val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },



      handleSearch() {
        this.getapplylist(this.searchVal);
      },
      // 点击节点
      // 翻页
      changePage(value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getapplylist(this.searchVal)
        }else{
          this.getapplylist()
        }
      },
      // 切换分页
      handlePageSize(value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getapplylist(this.searchVal)
        }else{
          this.getapplylist()
        }
      },
      searchinput(){

        if (this.searchVal) {
          this.getapplylist(this.searchVal)
        }else{
            this.getapplylist()
        }
      }
    },

    watch: {
      searchVal(val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted() {
      this.getapplylist();

    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
